export function accessoryPrice(cents) {
 return cents - Math.floor(cents / 10);
}

if (!customElements.get('pawture-accessory-prices')) {
 customElements.define('pawture-accessory-prices', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();
   this.abort = new AbortController();
   this.prices = JSON.parse(this.querySelector('[data-accessory-prices]').textContent);
   this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency});
   const schedule = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.render());
   };
   this.addEventListener('change',schedule,{signal:this.abort.signal});
   schedule();
  }
  disconnectedCallback() { this.abort?.abort();cancelAnimationFrame(this.frame); }
  render() {
   const select=this.querySelector('select[data-addon-kind="harness"]');
   const target=this.querySelector('[data-harness-price]');
   if (!target || !select) return;
   // Show the actual discounted add-on cost before a customer chooses a mode.
   // Keep option values and engraving-mode metadata untouched for cart handling.
   for (const option of select.options) {
    option.dataset.priceLabel ||= option.dataset.engravingMode || option.textContent;
    const item=this.prices.find(price => String(price.id)===option.value && price.available);
    const amount=option.value ? (item ? accessoryPrice(item.price) : null) : 0;
    option.textContent=option.dataset.priceLabel + (amount===null ? '' : ' — '+this.money.format(amount/100));
   }
   const variant=this.prices.find(item => String(item.id)===select.value && item.available);
   target.hidden=!variant;
   if (!variant) { target.replaceChildren(); return; }
   const original=document.createElement('s'), sale=document.createElement('strong');
   original.setAttribute('aria-label',this.dataset.regularLabel);
   sale.setAttribute('aria-label',this.dataset.discountedLabel);
   original.textContent=this.money.format(variant.price/100);
   sale.textContent=this.money.format(accessoryPrice(variant.price)/100);
   target.className='pawture-accessory-price';
   target.replaceChildren(original,sale);
  }
 });
}
